import { useIsMutating } from '@tanstack/react-query';

import { ESHOP_MUTATION_KEY } from '../model';

export const useIsGiftsSliderLoaderActive = () => {
    const { ADD_CART_ENTRY, ADD_RATE_PLAN, DELETE_RATE_PLAN, DELETE_LEASING_PLAN, ADD_LEASING_PLAN } =
        ESHOP_MUTATION_KEY;
    const addRatePlanIsLoading = useIsMutating({ mutationKey: [ADD_RATE_PLAN], exact: true });
    const addLeasingPlanIsLoading = useIsMutating({ mutationKey: [ADD_LEASING_PLAN], exact: true });
    const addCartEntryIsLoading = useIsMutating({ mutationKey: [ADD_CART_ENTRY], exact: true });
    const deleteRatePlanIsLoading = useIsMutating({ mutationKey: [DELETE_RATE_PLAN], exact: true });
    const deleteLeasingPlanIsLoading = useIsMutating({ mutationKey: [DELETE_LEASING_PLAN], exact: true });

    return !!(
        addRatePlanIsLoading ||
        addLeasingPlanIsLoading ||
        addCartEntryIsLoading ||
        deleteRatePlanIsLoading ||
        deleteLeasingPlanIsLoading
    );
};
